export const getBasketType = (item) => {
  const type = String(
    item?.basketType || item?.content_type || item?.type || "course",
  )
    .toLowerCase()
    .replace(/[\s_+-]/g, "");
  if (type === "template") return "template";
  if (type === "personalise" || type === "personalize") return "personalise";
  if (type === "track") return "track";
  if (type === "digitalproduct" || type === "digital") return "digital-product";
  return "course";
};

export const isCreatorPurchase = (item) =>
  ["template", "personalise"].includes(getBasketType(item));

export const getBasketPrice = (item) => ({
  amount: Number(
    item?.price?.amount ??
      (getBasketType(item) === "personalise"
        ? item?.personalise_price
        : item?.pricing) ??
      0,
  ),
  currency: item?.price?.currency || "GBP",
});

export const getBasketAccess = (role) => ({
  learning: role !== "creator",
  teaching: role === "creator" || role === "both",
});

export const getBasketKey = (item) => `${getBasketType(item)}:${item?._id}`;

export const splitBasketItems = (items = []) => ({
  learning: items.filter((item) => !isCreatorPurchase(item)),
  teaching: items.filter(isCreatorPurchase),
});

export const getBasketCheckoutGroups = (items = []) => {
  const groups = splitBasketItems(items);
  return [
    ...(groups.learning.length
      ? [{ key: "learning", items: groups.learning }]
      : []),
    ...groups.teaching.map((item) => ({
      key: getBasketKey(item),
      items: [item],
    })),
  ];
};

export const normalizeCreatorPurchase = (entry) => ({
  ...entry.product,
  basketType:
    getBasketType(entry) === "personalise" ? "personalise" : "template",
  purchaseId: entry._id,
  purchasedAt: entry.purchasedAt || entry.createdAt,
});

export const getCreatorPurchaseHistory = (response) => {
  const purchases = (response?.data || [])
    .filter(
      (entry) =>
        entry?.product?._id && ["template", "personalise"].includes(entry.type),
    )
    .map(normalizeCreatorPurchase);
  const existingKeys = new Set(purchases.map(getBasketKey));
  const memberships = (response?.pssmemberships || [])
    .filter((entry) => entry?.product?._id)
    .map(normalizeCreatorPurchase)
    .filter((item) => {
      const key = getBasketKey(item);
      if (existingKeys.has(key)) return false;
      existingKeys.add(key);
      return true;
    });

  return [...purchases, ...memberships];
};
